import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'mm-autocomplete-input',
    templateUrl: './mm-autocomplete-input.component.html',
    styleUrls: ['./mm-autocomplete-input.component.scss'],
})
export class MmAutocompleteInputComponent implements OnInit {
    @Input() placeholder: string = '';
    @Input() list: any;
    @Input() listAttributeName: string;
    selectedValue: any;
    @Output() sendValue: EventEmitter<any> = new EventEmitter();
    listBkp: any = [];
    showList: boolean = false;


    constructor() { }

    ngOnInit() {
        this.listBkp = this.list;
    }

    filterAutodeclaration(event: any) {
        this.showList = true;
        const valor = event.detail.value || '';
        this.selectedValue = valor;
        if (!valor.trim()) {
            this.list = this.listBkp;
            return;
        }

        this.list = this.list.filter((item: any) =>
            item[this.listAttributeName]
                .toLowerCase()
                .includes(valor.toLowerCase())
        );
    }

    selectAutodeclaration(item: any) {
        this.selectedValue = item[this.listAttributeName];
        this.showList = false;
        this.sendValue.emit(item)
    }

    stateChange(ev: any) {
        if (ev.detail.type == 'focus') {
            this.showList = true;
        } else if (ev.detail.type === 'blur' && (!ev.detail.relatedTarget || (ev.detail.relatedTarget && !ev.detail.relatedTarget.id.includes('autocomplete'))
        )) {
            this.showList = false;
        }
    }
}
